import { tokens } from '@domain-group/fe-brary';
import { customThemeVariants, outlineButtonStyles } from '../utils';
var _tokens$colors = tokens.colors,
  neutral = _tokens$colors.neutral,
  interactive = _tokens$colors.interactive;
export default customThemeVariants(outlineButtonStyles, {
  light: {
    base: {
      default: neutral.heavy.default,
      hover: interactive.base.default
    },
    surface: {
      hover: interactive.surface.hover,
      pressed: interactive.surface.pressed
    },
    trim: {
      default: neutral.trim.default,
      hover: interactive.base.default,
      pressed: interactive.trim.pressed
    }
  },
  dark: {
    base: {
      default: neutral.heavy.default,
      hover: interactive.base.default
    },
    surface: {
      hover: interactive.surface.hover,
      pressed: interactive.surface.pressed
    },
    trim: {
      default: interactive.trim.default,
      hover: interactive.base.default,
      pressed: interactive.trim.pressed
    }
  }
});